<template>
    <div class="app-container">
        <inner-children-renderer v-if="_child" :children="_child" />
    </div>
</template>

<script>
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');

import { isFTNN, isMoomoo } from '@futuweb/tool-browser/dist/browser.es6';

import ChildItem from '../children/item/render/index.vue';
import { CHILD, INSIDE, OUTSIDE } from '../constant';
import { getPageDebuggerParams } from './utils';

export default {
    name: 'app-container',

    mixins: [
        ComplexComp.Inner.Parent.Mixins({
            [CHILD]: ChildItem
        })
    ],

    props: ['tpl'],

    data() {
        return {
            activeIdx: this.tpl.props.defaultActive
        };
    },

    computed: {
        _child() {
            if (this.activeIdx === -1) {
                return null;
            }

            return this.tpl.children[this.activeIdx];
        }
    },

    created() {
        // 调试场景下 使用调试参数
        const pageDebuggerParams = getPageDebuggerParams();
        if (pageDebuggerParams && pageDebuggerParams.inside !== '') {
            this.activeIdx = pageDebuggerParams.inside;
            return;
        }

        this.activeIdx = isFTNN() || isMoomoo() ? INSIDE : OUTSIDE;
    }
};
</script>

<style lang="less" scoped>
.app-container {
    height: auto !important;
}
</style>
